/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Chars_LabelInputs */



/**
* | output |
* | --- |
* | "Chars" |
*
* @param {Event_Warning_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_chars_label = /** @type {((inputs?: Event_Warning_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caract.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Charaktere")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caratteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Чары")
	if (locale === "es") return /** @type {LocalizedString} */ ("Caracteres")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घर का काम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Personagens")
	return /** @type {LocalizedString} */ ("Chars")
});